export const SERVICE_NAMES = {
	main: 'Platform',
	public: 'Event Nodes',
	history: 'History',
};
